import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-information-general',
    templateUrl: './information-general.component.html',
    styleUrls: ['./information-general.component.scss']
})
export class InformationGeneralComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    @Output() extChange = new EventEmitter();

    user: User = Object.assign({}, EMPTY_USER);

    priceChoice = {};
    isLogin = false;

    constructor(public cityService: CityService,
                public adService: AdService,
                public commonService: CommonService,
                public authenticationService: AuthenticationService,
                public dialog: MatDialog) {
    }

    edit(event, fields = '') {

        this.favorite = this.adService.cleanInput(this.favorite);
        this.priceChoice = this.cityService.getPriceChoice(this.favorite.ad_city, this.favorite.iris);

        if (fields == 'advice_price_choice') {
            var regexp = new RegExp("'([0-9])'");
            if (regexp.test(this.favorite.advice_price_choice) === true) {
                var res = regexp.exec(this.favorite.advice_price_choice);
                this.favorite.rooms = parseInt(res[1]);
            } else {
                this.favorite.rooms = 0;
            }

            if (this.favorite.advice_price_choice.includes('.A')) {
                this.favorite.estate_type = "Appartement";
                if (this.favorite.rooms > 0) {
                    this.favorite.advice_rent_choice = "city.loyer_moyen_ville_nb_piece['"+(this.favorite.rooms > 5 ? '5' : this.favorite.rooms)+"']";
                } else {
                    this.favorite.advice_rent_choice = "city.loyer_moyen_ville.A";
                }
            } else if (this.favorite.advice_price_choice.includes('.M')) {
                if (this.favorite.rooms > 0) {
                    this.favorite.advice_rent_choice = "city.loyer_moyen_ville_nb_piece['"+(this.favorite.rooms > 5 ? '5' : this.favorite.rooms)+"']";
                } else {
                    this.favorite.advice_rent_choice = "city.loyer_moyen_ville.M";
                }
                this.favorite.estate_type = "Maison";
            } else if (this.favorite.advice_price_choice.includes('.P')) {
                this.favorite.advice_rent_choice = "city.loyer_moyen_ville.P";
                this.favorite.estate_type = "Parking";
            } else if (this.favorite.advice_price_choice.includes('.T')) {
                this.favorite.advice_rent_choice = "";
                this.favorite.estate_type = "Terrain";
            } else if (this.favorite.advice_price_choice.includes('.I')) {
                this.favorite.advice_rent_choice = "city.loyer_moyen_ville.A";
                this.favorite.estate_type = "Immeuble";
            }
        }

        if (fields === 'price') {
            // Set to null to calculate it
            if (this.favorite.apport === this.favorite.notary_price) {
                this.favorite.apport = null;
            }
            this.favorite.notary_price = null;
        }

        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'price') {
                this.favorite.other_fees = null;
            }
            if (fields === 'square') {
                this.favorite.building_insurance = null;
            }
        }

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    ngOnInit() {
        this.isLogin = this.authenticationService.isLogin;
        this.favorite = this.adService.updateValues(this.favorite);
        this.priceChoice = this.cityService.getPriceChoice(this.favorite.ad_city, this.favorite.iris);

        this.extChange.subscribe(data => {
            this.priceChoice = this.cityService.getPriceChoice(this.favorite.ad_city, this.favorite.iris);
        });

        this.user = this.authenticationService.currentUser;
    }
}
